(() => {
  const STORAGE_PREFIX = 'bob_sub_widget:';
  const AMPLITUDE_HTTP_ENDPOINT = 'https://api2.amplitude.com/2/httpapi';
  const AMPLITUDE_PUBLIC_API_KEY = '8fc6fd97524028c77f99a6700cdf5ac5';
  const FUNNEL_TRACKING_VERSION = 'v3';
  const INSTRUMENTATION_ENVIRONMENT = 'production';
  const AMPLITUDE_RETRY_INTERVAL_MS = 250;
  const AMPLITUDE_RETRY_MAX_ATTEMPTS = 80;
  function money(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format || '$ {{amount}}'.replace(' ', ''));
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function discountBadge(compareAtPrice, subscriptionPrice, moneyFormat) {
    const discount = Math.max(0, Number(compareAtPrice || 0) - Number(subscriptionPrice || 0));
    if (!discount || !compareAtPrice) return '';

    const percent = (discount / compareAtPrice) * 100;
    const roundedPercent = Math.round(percent);
    const isWholeDollarDiscount = discount % 100 === 0;
    const isCommonCleanPercent = Math.abs(percent - roundedPercent) < 0.05 && [5, 10, 15, 20, 25, 30, 40, 50].includes(roundedPercent);

    if (isCommonCleanPercent && !isWholeDollarDiscount) {
      return 'Save ' + roundedPercent + '%';
    }

    return 'Save ' + money(discount, moneyFormat);
  }

  function json(el) {
    try { return JSON.parse(el.textContent || '{}'); }
    catch (e) { return null; }
  }

  function normalizedQuantity(value) {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function quantity(form, override) {
    const overrideQuantity = normalizedQuantity(override);
    if (overrideQuantity) return overrideQuantity;

    const input = form && form.querySelector('[name="quantity"]');
    const inputQuantity = input ? normalizedQuantity(input.value) : null;
    return inputQuantity || 1;
  }

  function quantityFromEvent(event) {
    return event && event.detail ? normalizedQuantity(event.detail.quantity) : null;
  }

  function variantId(widget, form) {
    const input = form && form.querySelector('[name="id"]');
    if (input && input.value) return String(input.value);
    const fallback = document.querySelector('[name="id"]');
    if (fallback && fallback.value) return String(fallback.value);
    return widget._aswData.variants[0] ? String(widget._aswData.variants[0].id) : '';
  }

  function variant(data, id) {
    return data.variants.find((v) => String(v.id) === String(id)) || data.variants[0];
  }

  function allocation(widget, currentVariant) {
    const allocations = currentVariant && currentVariant.allocations ? currentVariant.allocations : [];
    return allocations.find((a) => String(a.sellingPlanId) === String(widget.dataset.selectedSellingPlanId)) || allocations[0];
  }

  function layoutModeForViewport(widget) {
    const isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    const fallback = widget.dataset.layoutMode || 'cards';
    return isMobile ? (widget.dataset.mobileLayoutMode || fallback) : (widget.dataset.desktopLayoutMode || fallback);
  }

  function viewportName() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
  }

  function experimentOverride() {
    try {
      const value = new URLSearchParams(window.location.search).get('bob_sub_card_order');
      return value === 'one_time_first' || value === 'subscription_first' ? value : '';
    } catch (e) {
      return '';
    }
  }

  function experimentEventId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
    } catch (e) {}

    return String(Date.now()) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function amplitudeIdentity() {
    try {
      if (
        !window.amplitude ||
        typeof window.amplitude.getDeviceId !== 'function' ||
        typeof window.amplitude.getSessionId !== 'function'
      ) return null;

      const deviceId = window.amplitude.getDeviceId();
      if (!deviceId) return null;

      const identity = {
        device_id: String(deviceId),
        session_id: Number(window.amplitude.getSessionId()) || undefined
      };

      if (typeof window.amplitude.getUserId === 'function') {
        const userId = window.amplitude.getUserId();
        if (userId) identity.user_id = String(userId);
      }

      return identity;
    } catch (e) {
      return null;
    }
  }

  function sendAmplitudeEvent(eventName, properties, attempt, insertId) {
    const currentAttempt = Number(attempt || 0);
    const currentInsertId = insertId || experimentEventId();
    const identity = amplitudeIdentity();

    if (!identity) {
      if (currentAttempt < AMPLITUDE_RETRY_MAX_ATTEMPTS) {
        window.setTimeout(
          () => sendAmplitudeEvent(eventName, properties, currentAttempt + 1, currentInsertId),
          AMPLITUDE_RETRY_INTERVAL_MS
        );
      }
      return;
    }

    const event = {
      device_id: identity.device_id,
      event_type: eventName,
      insert_id: currentInsertId,
      time: Date.now(),
      platform: 'Web',
      ip: '$remote',
      language: navigator.language || '',
      user_agent: navigator.userAgent || '',
      library: 'bob-subscription-ab/3.0',
      event_properties: Object.assign({
        analytics_delivery_path: 'http_v2_direct_v3',
        instrumentation_environment: INSTRUMENTATION_ENVIRONMENT
      }, properties || {})
    };

    if (identity.session_id) event.session_id = identity.session_id;
    if (identity.user_id) event.user_id = identity.user_id;

    fetch(AMPLITUDE_HTTP_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        api_key: AMPLITUDE_PUBLIC_API_KEY,
        client_upload_time: new Date().toISOString(),
        events: [event],
        options: {}
      })
    }).then((response) => {
      if (
        !response.ok &&
        (response.status === 429 || response.status >= 500) &&
        currentAttempt < AMPLITUDE_RETRY_MAX_ATTEMPTS
      ) {
        window.setTimeout(
          () => sendAmplitudeEvent(eventName, properties, currentAttempt + 1, currentInsertId),
          AMPLITUDE_RETRY_INTERVAL_MS
        );
      }
    }).catch(() => {
      if (currentAttempt < AMPLITUDE_RETRY_MAX_ATTEMPTS) {
        window.setTimeout(
          () => sendAmplitudeEvent(eventName, properties, currentAttempt + 1, currentInsertId),
          AMPLITUDE_RETRY_INTERVAL_MS
        );
      }
    });
  }

  function trackEvent(widget, eventName, properties) {
    const payload = Object.assign({
      product_id: widget.dataset.productId || '',
      viewport: viewportName(),
      active_layout: widget.dataset.activeLayout || '',
      card_order_variant: widget.dataset.cardOrder || '',
      card_order_experiment: widget.dataset.cardOrderExperimentName || '',
      funnel_tracking_version: widget.dataset.cardOrderAssignmentSource === 'experiment' ? FUNNEL_TRACKING_VERSION : ''
    }, properties || {});

    sendAmplitudeEvent(eventName, payload);

    try {
      document.dispatchEvent(new CustomEvent('bob:subscription-widget:event', {
        detail: { eventName, properties: payload }
      }));
    } catch (e) {}
  }

  function cardOrderExperimentApplies(widget, viewport) {
    const scope = widget.dataset.cardOrderTestScope || 'mobile';
    return scope === 'all' || scope === viewport;
  }

  function syncExperimentProperties(widget, assignmentSource) {
    const form = document.getElementById(widget.dataset.productFormId);
    if (!form) return;

    form.querySelectorAll('[data-asw-experiment-property]').forEach((input) => input.remove());
    if (assignmentSource !== 'experiment') return;

    const properties = {
      _bob_sub_card_experiment: widget.dataset.cardOrderExperimentName || 'subscription_card_order_v1',
      _bob_sub_card_variant: widget.dataset.cardOrder || 'one_time_first',
      _bob_sub_card_scope: viewportName(),
      _bob_sub_funnel_version: 'v3'
    };

    Object.entries(properties).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + key + ']';
      input.value = value;
      input.setAttribute('data-asw-experiment-property', key);
      form.appendChild(input);
    });
  }

  function applyCardOrder(widget) {
    const viewport = viewportName();
    const mode = widget.dataset.cardOrderMode || 'one_time_first';
    const override = experimentOverride();
    let assigned = 'one_time_first';

    if (override) {
      assigned = override;
    } else if (mode === 'subscription_first') {
      assigned = 'subscription_first';
    } else if (mode === 'ab_test' && cardOrderExperimentApplies(widget, viewport)) {
      const key = STORAGE_PREFIX + (widget.dataset.cardOrderExperimentName || 'subscription_card_order_v1') + ':card_order:' + viewport;
      try { assigned = localStorage.getItem(key) || ''; } catch (e) {}

      if (assigned !== 'one_time_first' && assigned !== 'subscription_first') {
        const percent = parseInt(widget.dataset.abSubscriptionFirstPercent || '50', 10);
        assigned = Math.random() * 100 < percent ? 'subscription_first' : 'one_time_first';
        try { localStorage.setItem(key, assigned); } catch (e) {}
      }
    }

    widget.dataset.cardOrder = assigned;

    const isExperimentAssignment = mode === 'ab_test' && cardOrderExperimentApplies(widget, viewport) && !override;
    const assignmentSource = override ? 'url_override' : (isExperimentAssignment ? 'experiment' : 'fixed');
    widget.dataset.cardOrderAssignmentSource = assignmentSource;
    syncExperimentProperties(widget, assignmentSource);

    if (widget.dataset.activeLayout === 'cards') {
      const exposureKey = viewport + ':' + assigned + ':' + assignmentSource;
      if (widget.dataset.aswCardOrderExposure !== exposureKey) {
        widget.dataset.aswCardOrderExposure = exposureKey;
        trackEvent(widget, 'BOB Subscription Card Experiment Viewed', {
          experiment_name: widget.dataset.cardOrderExperimentName || 'subscription_card_order_v1',
          variant: assigned,
          scope: widget.dataset.cardOrderTestScope || 'mobile',
          assignment_source: assignmentSource,
          default_purchase_option: widget.dataset.defaultState || 'one_time'
        });
      }
    }
  }

  function layout(widget) {
    const mode = layoutModeForViewport(widget);
    if (mode !== 'ab_test') {
      widget.dataset.activeLayout = mode === 'toggle' ? 'toggle' : 'cards';
    } else {
      const viewport = viewportName();
      const key = STORAGE_PREFIX + (widget.dataset.experimentName || 'subscription_widget_v1') + ':' + viewport;
      let assigned = '';
      try { assigned = localStorage.getItem(key) || ''; } catch (e) {}

      if (assigned !== 'cards' && assigned !== 'toggle') {
        assigned = Math.random() * 100 < parseInt(widget.dataset.abTogglePercent || '50', 10) ? 'toggle' : 'cards';
        try { localStorage.setItem(key, assigned); } catch (e) {}
      }

      widget.dataset.activeLayout = assigned;
    }

    applyCardOrder(widget);
  }

  function ensureFormSellingPlanInput(form) {
    if (!form) return null;

    let input = form.querySelector('input[name="selling_plan"][data-asw-form-selling-plan-input]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.setAttribute('data-asw-form-selling-plan-input', '');
      form.appendChild(input);
    }

    return input;
  }

  function clearSellingPlan(widget, form) {
    const widgetSellingPlanInput = widget ? widget.querySelector('[data-asw-selling-plan-input]') : null;
    const formSellingPlanInput = form ? form.querySelector('input[name="selling_plan"][data-asw-form-selling-plan-input]') : null;

    if (widgetSellingPlanInput) widgetSellingPlanInput.value = '';
    if (formSellingPlanInput) formSellingPlanInput.value = '';
  }

  function populate(widget, currentVariant) {
    const allocations = currentVariant && currentVariant.allocations ? currentVariant.allocations : [];
    const selected = widget.dataset.selectedSellingPlanId;

    widget.querySelectorAll('[data-asw-frequency-select]').forEach((select) => {
      select.innerHTML = allocations.map((a) => '<option value="' + a.sellingPlanId + '">' + a.sellingPlanName + '</option>').join('');
      const hasSelected = allocations.some((a) => String(a.sellingPlanId) === String(selected));
      select.value = hasSelected ? selected : (allocations[0] ? allocations[0].sellingPlanId : '');
    });

    const first = widget.querySelector('[data-asw-frequency-select]');
    widget.dataset.selectedSellingPlanId = first ? first.value : '';
  }

  function select(widget, enabled) {
    widget.dataset.subscriptionEnabled = enabled ? 'true' : 'false';
    widget.querySelectorAll('[data-asw-select="one_time"]').forEach((el) => {
      el.classList.toggle('is-selected', !enabled);
      el.setAttribute('aria-pressed', enabled ? 'false' : 'true');
    });
    widget.querySelectorAll('[data-asw-select="subscription"], [data-asw-toggle-card]').forEach((el) => {
      el.classList.toggle('is-selected', enabled);
    });
    widget.querySelectorAll('[data-asw-toggle]').forEach((el) => el.setAttribute('aria-pressed', enabled ? 'true' : 'false'));
    update(widget);
  }

  function update(widget, quantityOverride) {
    const data = widget._aswData;
    const form = document.getElementById(widget.dataset.productFormId);
    const currentVariant = variant(data, variantId(widget, form));

    if (!currentVariant || currentVariant.available === false || !currentVariant.allocations || currentVariant.allocations.length === 0) {
      widget.hidden = true;
      clearSellingPlan(widget, form);
      return;
    }

    widget.hidden = false;
    populate(widget, currentVariant);

    const currentAllocation = allocation(widget, currentVariant);
    const isSubscription = widget.dataset.subscriptionEnabled === 'true';
    const q = quantity(form, quantityOverride);
    const oneTimePrice = currentVariant.price || 0;
    const subscriptionPrice = currentAllocation ? currentAllocation.price : oneTimePrice;
    const compareAt = currentAllocation && currentAllocation.compareAtPrice ? currentAllocation.compareAtPrice : oneTimePrice;
    const oneTimeLinePrice = oneTimePrice * q;
    const subscriptionLinePrice = subscriptionPrice * q;
    const savings = Math.max(0, (compareAt - subscriptionPrice) * q);
    const sellingPlanValue = isSubscription && currentAllocation ? String(currentAllocation.sellingPlanId) : '';
    const widgetSellingPlanInput = widget.querySelector('[data-asw-selling-plan-input]');
    const formSellingPlanInput = ensureFormSellingPlanInput(form);
    const badgeText = discountBadge(compareAt, subscriptionPrice, data.moneyFormat);

    widget.querySelectorAll('[data-asw-one-time-price]').forEach((el) => el.textContent = money(oneTimeLinePrice, data.moneyFormat));
    widget.querySelectorAll('[data-asw-subscription-price]').forEach((el) => el.textContent = currentAllocation ? money(subscriptionLinePrice, data.moneyFormat) : '');
    widget.querySelectorAll('[data-asw-subscription-compare-price]').forEach((el) => {
      el.textContent = currentAllocation && oneTimeLinePrice > subscriptionLinePrice ? money(oneTimeLinePrice, data.moneyFormat) : '';
      el.hidden = !(currentAllocation && oneTimeLinePrice > subscriptionLinePrice);
    });
    widget.querySelectorAll('.asw__badge').forEach((el) => {
      el.textContent = badgeText;
      el.hidden = !badgeText;
    });
    widget.querySelectorAll('[data-asw-savings-text]').forEach((el) => {
      el.textContent = savings > 0 ? (widget.dataset.savingsPrefix || 'Save') + ' ' + money(savings, data.moneyFormat) + ' ' + (widget.dataset.savingsSuffix || 'today') : '';
    });
    widget.querySelectorAll('[data-asw-savings-item]').forEach((el) => el.hidden = savings <= 0);

    if (widgetSellingPlanInput) widgetSellingPlanInput.value = sellingPlanValue;
    if (formSellingPlanInput) formSellingPlanInput.value = sellingPlanValue;

    const debug = widget.querySelector('[data-asw-debug-value]');
    if (debug) debug.textContent = sellingPlanValue ? 'selling_plan = ' + sellingPlanValue + ', quantity = ' + q : 'selling_plan = blank, quantity = ' + q;
  }

  async function addSubscriptionDirectly(event, widget, form) {
    if (!widget || !form || widget.dataset.subscriptionEnabled !== 'true') return false;

    update(widget);

    const sellingPlanInput = form.querySelector('input[name="selling_plan"][data-asw-form-selling-plan-input]');
    const sellingPlanValue = sellingPlanInput ? sellingPlanInput.value : '';
    if (!sellingPlanValue) return false;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (widget.dataset.aswSubmitting === 'true') return true;
    widget.dataset.aswSubmitting = 'true';

    trackEvent(widget, 'BOB Subscription Add To Cart', {
      selling_plan_id: sellingPlanValue,
      selected_option: 'subscription'
    });

    const submitButton = form.querySelector('[type="submit"][name="add"], [type="submit"]') || document.querySelector('[name="add"], .product-form__submit');
    const productFormElement = form.closest('product-form');
    const loadingOverlay = productFormElement ? productFormElement.querySelector('.loading-overlay') : null;

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
    }
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');

    const formData = new FormData(form);
    formData.delete('selling_plan');
    formData.append('selling_plan', sellingPlanValue);

    try {
      const addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
      const response = await fetch(addUrl + '.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        },
        body: formData
      });
      const result = await response.json();

      if (!response.ok) throw new Error(result.description || 'Unable to add subscription to cart.');

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: result }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: result }));
    } catch (error) {
      const errorWrapper = productFormElement ? productFormElement.querySelector('.product-form__error-message-wrapper') : null;
      const errorMessage = errorWrapper ? errorWrapper.querySelector('.product-form__error-message') : null;

      if (errorWrapper && errorMessage) {
        errorMessage.textContent = error.message;
        errorWrapper.removeAttribute('hidden');
      } else {
        console.error(error);
        alert(error.message);
      }
    } finally {
      widget.dataset.aswSubmitting = 'false';
      if (submitButton) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      }
      if (loadingOverlay) loadingOverlay.classList.add('hidden');
    }

    return true;
  }

  function activeSubscriptionContext(target) {
    const activeWidgets = Array.from(document.querySelectorAll('[data-appstle-subscription-widget][data-subscription-enabled="true"]'));
    if (!activeWidgets.length) return null;

    const clickedForm = target && target.closest ? target.closest('form') : null;
    let widget = clickedForm ? activeWidgets.find((candidate) => candidate.dataset.productFormId === clickedForm.id) : null;
    if (!widget) widget = activeWidgets[0];

    const form = document.getElementById(widget.dataset.productFormId);
    if (!form) return null;

    return { widget, form };
  }

  function installGlobalAddToCartInterceptor() {
    if (window.__aswGlobalAddToCartInterceptorInstalled) return;
    window.__aswGlobalAddToCartInterceptorInstalled = true;
    window.__aswSubscriptionWidgetVersion = 'direct-cart-global-v12-http-exposure-v3';

    document.addEventListener('click', (event) => {
      const addButton = event.target.closest && event.target.closest('[name="add"], .product-form__submit, button[type="submit"], input[type="submit"]');
      if (!addButton) return;

      const context = activeSubscriptionContext(event.target);
      if (context) addSubscriptionDirectly(event, context.widget, context.form);
    }, true);

    document.addEventListener('submit', (event) => {
      const context = activeSubscriptionContext(event.target);
      if (context) addSubscriptionDirectly(event, context.widget, context.form);
    }, true);
  }

  function init(widget) {
    if (widget.dataset.aswInitialized === 'true') return;
    widget.dataset.aswInitialized = 'true';

    const data = json(widget.querySelector('[data-asw-data]'));
    if (!data || !data.variants || !data.variants.length) return;
    widget._aswData = data;
    layout(widget);

    const responsiveLayoutQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    if (responsiveLayoutQuery) {
      const handleResponsiveLayoutChange = () => layout(widget);
      if (typeof responsiveLayoutQuery.addEventListener === 'function') responsiveLayoutQuery.addEventListener('change', handleResponsiveLayoutChange);
      else if (typeof responsiveLayoutQuery.addListener === 'function') responsiveLayoutQuery.addListener(handleResponsiveLayoutChange);
    }

    widget.querySelectorAll('[data-asw-select="one_time"]').forEach((el) => el.addEventListener('click', () => {
      trackEvent(widget, 'BOB Subscription Purchase Option Selected', { selected_option: 'one_time', control: 'card' });
      select(widget, false);
    }));
    widget.querySelectorAll('[data-asw-select="subscription"]').forEach((el) => el.addEventListener('click', () => {
      trackEvent(widget, 'BOB Subscription Purchase Option Selected', { selected_option: 'subscription', control: 'card' });
      select(widget, true);
    }));
    widget.querySelectorAll('[data-asw-toggle]').forEach((el) => el.addEventListener('click', () => {
      const enabling = widget.dataset.subscriptionEnabled !== 'true';
      trackEvent(widget, 'BOB Subscription Purchase Option Selected', { selected_option: enabling ? 'subscription' : 'one_time', control: 'toggle' });
      select(widget, enabling);
    }));
    widget.querySelectorAll('[data-asw-frequency-select]').forEach((el) => el.addEventListener('change', () => { widget.dataset.selectedSellingPlanId = el.value; update(widget); }));

    const form = document.getElementById(widget.dataset.productFormId);
    if (form) {
      ensureFormSellingPlanInput(form);

      const handleQuantityChange = (event) => {
        if (event && event.detail && event.detail.formId && event.detail.formId !== form.id) return;
        update(widget, quantityFromEvent(event));
      };

      form.addEventListener('input', () => update(widget));
      form.addEventListener('change', () => update(widget));
      document.addEventListener('bob:pack-selector:change', handleQuantityChange);
      window.addEventListener('bob:pack-selector:change', handleQuantityChange);
      document.addEventListener('quantity:change', handleQuantityChange);
      window.addEventListener('quantity:change', handleQuantityChange);
      form.addEventListener('submit', (event) => addSubscriptionDirectly(event, widget, form), true);
      form.addEventListener('click', (event) => {
        if (event.target.closest('[type="submit"][name="add"], [type="submit"]')) {
          addSubscriptionDirectly(event, widget, form);
        }
      }, true);
    }

    document.addEventListener('variant:change', () => update(widget));
    document.addEventListener('product:variant-change', () => update(widget));
    select(widget, widget.dataset.defaultState === 'subscription');
  }

  function initAll() {
    installGlobalAddToCartInterceptor();
    document.querySelectorAll('[data-appstle-subscription-widget]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
